angular.module("digitalLeasing.module").component("leasingHypothesis", {
  templateUrl: "ng/components/digitalLeasing/leasingHypothesis/leasingHypothesis.view.html",
  bindings: {
    vendor: "=",
    customer: "<",
    model: "=",
    financialModel: '<',
    validatePage: '&',
    invalidatePage: '&',
    snapshot: '<',
    callFuncToAnagCliente: '&',
    restGoToStepDigitalEnd: '<'
  },
  controllerAs: "LeasingHypothesisCtrl",
  controller: LeasingHypothesisController
});

function LeasingHypothesisController(
  $financialApiService,
  $filter,
  $timeout,
  ModelForClientSignallerManager,
  $storageService,
  ConvenzionePlafond,
  Riferimenti,
  $configService
) {
  var self = this;

  self.$onInit = function () {

    if (!self.snapshot && $configService.getAppConfig().allFunctionalities.includes("PREVENTIVO_LEVEL0")) {
      self.setContacts();

    }
    self.populateContacts = 0;
    self.numberOfCharMax = 20;
    self.reteVenditaUser = $storageService.getAppConfig().user.reteVendita;
    self.reteVenditaCliente = self.vendor.reteVendita;
    self.supportModel = {
      container: [{
        id: "0",
        title: $filter("translate")("LBL_LEA_HYPO_PRODUCT"),
        class: "digital-product"
      },
      {
        id: "1",
        title: $filter("translate")("LBL_LEA_HYPO_GOOD"),
        class: "digital-good"
      },
      {
        id: "2",
        title: $filter("translate")("LBL_LEA_HYPO_SUPPLIER_FEE"),
        class: "digital-vendor-payment"
      }
      ],
      plafond: [],
      supplier: [],
      signalers: self.vendor.segnalatori || [],
      signaler: {},
      temp: [],
      clients: []
    };
    getGestiscePratica(self.reteVenditaCliente);
    self.importo = 0;
    if (self.reteVenditaUser == 2) {

      listOfClient(self.vendor.clientManager.ndg, self.vendor.clientManager.ragioneSociale, self.vendor.riUserG.ndg, self.vendor.reteVendita);
    }
    if (self.model.preventivo.segnalatore.ndg) {
      self.supportModel.signaler = self.model.preventivo.segnalatore
    }
    checkAndEnableTooltip();
    if (self.financialModel.financialVendor.mansioneAziendale == 'MED') {
      self.model.preventivo.venditoreGestiscePratica = false;
      self.disableGestionePratica = true;

    } else {
      self.disableGestionePratica = false;
    }
    self.setGestore(self.model.preventivo.venditoreGestiscePratica, true);
    if (!self.model.preventivo.venditoreGestiscePratica && self.reteVenditaCliente == 3) {

      callRestSegnalatori();

    }
    $timeout(function () {
      self.enableTooltipGoToAnagCli = true;
      checkFinancialCustomer();
    }, 500)
  };

  self.$onChanges = function (changed) {
    if (changed.restGoToStepDigitalEnd && changed.restGoToStepDigitalEnd.currentValue) {
      self.disabledIconAnag = !changed.restGoToStepDigitalEnd.currentValue;
    }
  }

  self.openAccordion = function (selector) {
    if (self.model.configuration.plafond.code) {
      var container = $(selector);
      var button = container.find("i[role=button]");
      var collapseContainer = container.find(
        "#collapseContainer.panel-collapse"
      );
      // button.toggle('icon-freccia-su icon-freccia-basso');
      // button.toggleClass('collapsed');
      $timeout(function () {
        button.trigger("click");
      }, 0);
      collapseContainer.toggleClass("in");
    }
  };


  self.handleProductChange = function (product, enableAccordion, marcaMandatory) {

    if (product.amount && product.description) {
      if (product.description == "AUTO" && product.freeQuote) {
        self.openAccordion("#accordion-container1");
      } else {
        self.openAccordion("#accordion-container1");
      }
    }
    self.enableOtherAccordion = enableAccordion;
    self.supportModel.supplier = product.supplier;
    self.importo = product.amount;
    self.supportModel.marcaMandatory = marcaMandatory;
  };

  self.handleGoodChange = function (good) {

    if (good.status && good.year && good.description) {
      self.openAccordion("#accordion-container2");
    }
  };

  self.handleSignaler = function (value) {

    self.model.preventivo.segnalatore = value;
  }

  self.handleVendorPayment = function (supplier) {

  };

  self.enableNextButton = function () { };



  var getGestiscePratica = function (reteVendita) {

    if ((reteVendita != 2 && reteVendita != 3) || self.model.preventivo.venditoreGestiscePratica ||
      (self.financialModel.financialVendor.mansioneAziendale == 'PRO' && reteVendita == 3)) {
      self.model.preventivo.venditoreGestiscePratica = true
    } else {
      self.model.preventivo.venditoreGestiscePratica = false;
    }

    if (reteVendita == 2 && self.model.preventivo.gestore.ndg) {
      self.disableGestionePratica = true;
      self.model.preventivo.venditoreGestiscePratica = false;
      self.model.preventivo.gestore = ModelForClientSignallerManager.build({
        ndg: "01321598",
        ragioneSociale: "Alba Leasing"
      })
    } else if (reteVendita == 3 && self.financialModel.financialVendor.mansioneAziendale != 'MED') {
      self.disableGestionePratica = false;
    } else {
      if (self.financialModel.financialVendor.mansioneAziendale != 'MED') {
        self.disableGestionePratica = false;
      }
      self.model.preventivo.gestore = ModelForClientSignallerManager.build({
        ndg: "01321598",
        ragioneSociale: "Alba Leasing"
      })
    }
  }

  self.setGestore = function (value, fromInit) {

    if (self.reteVenditaCliente == 3 && value) {
      self.model.preventivo.segnalatore = ModelForClientSignallerManager.build();
      self.model.preventivo.gestore = ModelForClientSignallerManager.build(self.vendor.riUserG);
    } else if ((self.reteVenditaCliente != 3 && self.reteVenditaCliente != 2 && value) ||
      (self.reteVenditaCliente == 3 && !value)) {
      if (!fromInit) {
        self.supportModel.signaler = "";
        self.model.preventivo.segnalatore = ModelForClientSignallerManager.build();
      }

    } else {
      if (!value) {
        self.model.preventivo.gestore = ModelForClientSignallerManager.build({
          ndg: "01321598",
          ragioneSociale: "Alba Leasing"
        })
      } else {
        self.model.preventivo.gestore = ModelForClientSignallerManager.build()
      }

    }

    if (self.model.preventivo.gestore.ndg == self.vendor.riUserG.ndg && self.vendor.reteVendita == 2) {

      self.enableErrorGestoreVenditore = true;
    } else {
      self.enableErrorGestoreVenditore = false;
    }
  }

  self.clientSelected = function (value) {

    self.vendor.clientManager = value;
  }
  var listOfClient = function (ndg, ragioneSociale, ndgVenditore, reteVenditore) {

    if (self.snapshot) {
      return;
    }

    $financialApiService.getAllClientManager(ndg, ragioneSociale, ndgVenditore, reteVenditore)
      .then(function (response) {
        self.supportModel.clients = response;
        if (self.vendor.clientManager && !self.vendor.clientManager.ndg) {
          self.vendor.clientManager = response
            .find(function (element) {
              return element.selected == true;
            })
        }
      })
      .catch(function (error) {
        console.log(error);
      })
  }

  var checkAndEnableTooltip = function () {

    $timeout(function () {
      if (self.vendor.riUserG.ragioneSociale && self.vendor.riUserG.ragioneSociale.length > self.numberOfCharMax) {
        self.enableToltipVendor = true;
      }
    }, 1000);
    $timeout(function () {
      if (self.vendor.filiale.ragioneSocialeBanca) {
        var infoFiliale = self.vendor.filiale.ragioneSocialeBanca + " " + self.vendor.filiale.descrizione;
        if (infoFiliale && infoFiliale.length > self.numberOfCharMax) {
          self.enableToltipFiliale = true;
        }
      }
    }, 1000);
    $timeout(function () {
      if (self.vendor.clientManager.ragioneSociale && self.vendor.clientManager.ragioneSociale.length > self.numberOfCharMax) {
        self.enableToltipClientManager = true;
      }
    }, 800);
    $timeout(function () {
      if (self.customer.metadata.riUserG.ragioneSociale && self.customer.metadata.riUserG.ragioneSociale.length > self.numberOfCharMax) {
        self.enableToltipClient = true;
      }
    }, 1200);
    $timeout(function () {
      if (self.vendor.descUnitaOrganizzativa && self.vendor.descUnitaOrganizzativa.length > self.numberOfCharMax) {
        self.enableToltipUnitOrganiz = true;
      }
    }, 1600);
    $timeout(function () {
      if (self.model.preventivo.gestore.ragioneSociale && self.model.preventivo.gestore.ragioneSociale.length > self.numberOfCharMax) {
        self.enableToltipGestore = true;
      }
    }, 5000);
  }

  self.validateLeasing = function () {
    if (self.reteVenditaCliente == 3) {
      if (self.model.preventivo.venditoreGestiscePratica) {

        var test = self.checkGood &&
          self.checkProduct &&
          self.checkVendor &&
          !!self.vendor.clientManager.ndg &&
          !!self.model.preventivo.gestore.ndg;
      } else {
        var test = self.checkGood &&
          self.checkProduct &&
          self.checkVendor &&
          !!self.vendor.clientManager.ndg &&
          !!self.model.preventivo.segnalatore.ndg;
      }

    } else {
      var test = self.checkGood &&
        self.checkProduct &&
        self.checkVendor &&
        !!self.vendor.clientManager.ndg &&
        !self.enableErrorGestoreVenditore;
    }

    if ($configService.getAppConfig().allFunctionalities.includes("PREVENTIVO_LEVEL0")) {
      test = test && self.validateContactVariable;
    }


    if (test) {
      self.validatePage();
    } else {
      self.invalidatePage();
    }
  }


  self.goodIsOk = function () {
    self.checkGood = true;
    self.validateLeasing();
  }

  self.goodIsNotOk = function () {
    self.checkGood = false;
    self.validateLeasing();
  }

  self.productIsOk = function () {
    self.checkProduct = true;
    self.validateLeasing();
  }

  self.productIsNotOk = function () {
    self.checkProduct = false;
    self.validateLeasing();
  }

  self.vendorIsOk = function () {
    self.checkVendor = true;
    self.validateLeasing();
  }

  self.vendorIsNotOk = function () {
    self.checkVendor = false;
    self.validateLeasing();
  }

  self.exportBaseValidation = function (value) {
    self.baseValidation = value;
  }

  self.modifyPreventive = function () {
    if (self.model.isTariffaPlafond) {
      self.model.preventivo.convenzionePlafond = ConvenzionePlafond.build();
    }
  }

  var callRestSegnalatori = function () {
    $financialApiService.getSegnalatori(self.model.id)
      .then(function (response) {
        self.supportModel.signalers = response;
      })
  }

  self.upgradeModPagamento = function (modalitaPagamento) {
    self.supportModel.supplier = modalitaPagamento;
  }

  self.setContacts = function () {
    var indexFromCustomer = self.model.preventivo.contatti.riferimenti
      .findIndex(function (element) {
        return element.id == "CLIENTE"
      });
    var indexFromBank = self.model.preventivo.contatti.riferimenti
      .findIndex(function (element) {
        return element.id == "BANCA"
      });
    if (indexFromCustomer < 0) {
      self.contactCustomer = Riferimenti.build({ id: "CLIENTE" })
      self.getCustomer()
    }
    if (indexFromBank < 0) {
      self.bank = Riferimenti.build({ id: "BANCA" })
      self.getBank();
    }
  }

  self.getBank = function () {
    $financialApiService
      .getContatti(self.financialModel.financialVendor.riUserG.ndg)
      .then(function (response) {
        if (response && response.riferimenti && response.riferimenti[0]) {
          response.riferimenti[0].id = "BANCA"
          self.model.preventivo.contatti.riferimenti.push(Riferimenti.build(response.riferimenti[0]));
          self.populateContacts = self.populateContacts + 1;
        }
      }).catch(function (error) {
        console.error(error);
      });
  }
  self.getCustomer = function () {
    $financialApiService
      .getContattiCliente(self.customer.metadata.riUserG)
      .then(function (response) {
        if (response && response.riferimenti && response.riferimenti[0]) {
          self.model.preventivo.contatti.riferimenti.push(Riferimenti.build(response.riferimenti[0]));
          self.populateContacts = self.populateContacts + 1;
        }
      }).catch(function (error) {
        console.error(error);
      });
  }

  self.validateContact = function (value) {
    self.validateContactVariable = value;
  }

  self.goToAnagraficaCliente = function () {
    self.disabledIconAnag = true;
    self.callFuncToAnagCliente();
  }

  var checkFinancialCustomer = function () {
    self.showTooltipFinancialCustomer = false;
    self.tooltipFinancialCustomer = "Il cliente selezionato si trova:<br/>"
    var sofferenza = "";
    var annullata = "";
    var osservazione = ""
    if (self.financialModel.financialCustomer.metadata.riUserG.warningAnagrafica.sofferenza || self.financialModel.financialCustomer.metadata.riUserG.warningAnagrafica.inOsservazione || self.financialModel.financialCustomer.metadata.riUserG.warningAnagrafica.deleted) {
      self.showTooltipFinancialCustomer = true;
    }

    if (self.financialModel.financialCustomer.metadata.riUserG.warningAnagrafica.sofferenza) {
      sofferenza = $filter("translate")(self.financialModel.financialCustomer.metadata.riUserG.warningAnagrafica.label) + "<br/>"
    }
    if (self.financialModel.financialCustomer.metadata.riUserG.warningAnagrafica.inOsservazione) {
      osservazione = "in osservazione;<br/>"
    }
    if (self.financialModel.financialCustomer.metadata.riUserG.warningAnagrafica.deleted) {
      annullata = "con anagrafica annullata."
    }
    self.tooltipFinancialCustomer = self.tooltipFinancialCustomer.concat(sofferenza).concat(osservazione).concat(annullata);

  }

}